export enum SignatureReason {
  APPROVAL = 'Approval',
  COMPLETION = 'Completion',
  DEFERRAL = 'Deferral',
  PREFLIGHT = 'Preflight',
  POSTFLIGHT = 'Postflight',
  STANDARD = 'Standard',
}

export interface Signature {
  subtype: SignatureReason;
  data_image: string;
  data_svg: string;
  signed_at: string;
}